// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._2rkofajl{border-radius:var(--ds-radius-small,3px)}._18m915vq{overflow-y:hidden}\n._1bah1h6o{justify-content:center}\n._1bsb1osq{width:100%}\n._1e0c1txw{display:flex}\n._1reo15vq{overflow-x:hidden}\n._2lx21bp4{flex-direction:column}\n._4cvr1h6o{align-items:center}\n._4t3i1osq{height:100%}\n._c71l1osq{max-height:100%}\n._kqswh2mm{position:relative}\n._p12f1osq{max-width:100%}", ""]);
// Exports
module.exports = exports;
